import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  card: {
    maxWidth: '600px',
    margin: '20px auto'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM
  },
  content: {
    padding: tokens.spacingVerticalL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM
  },
  button: {
    marginTop: tokens.spacingVerticalM
  }
});